import * as Actions from "../../actions/app"

const initialState = {

  users: null,

  loading_crud_user: false,
  crud_user: false,

  loading_user_series: false,
  user_series: null,

  loading_crud_user_serie: false,
  crud_user_serie: false

}

const usersReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_ALL_USERS: {
      return {
        ...state,
        users: action.payload
      }
    }

    case Actions.CRUD_USER: {
      return {
        ...state,
        loading_crud_user: action.payload.loading,
        crud_user: action.payload.crud,
      }
    }

    case Actions.GET_USER_SERIES: {
      return {
        ...state,
        loading_user_series: action.payload.loading,
        user_series: action.payload.data,
      }
    }

    case Actions.CRUD_USER_SERIE: {
      return {
        ...state,
        loading_crud_user_serie: action.payload.loading,
        crud_user_serie: action.payload.crud,
      }
    }

    default: {
      return state
    }
  }
}
export default usersReducer
